export const JSON_TYPE = 'application/json';
export const CSV_TYPE = 'text/csv';
export const ZIP_TYPE = 'application/zip';
